/**
 * Categories Service
 * Handles all category-related API calls
 */

import network from '../../Network/NetworkManager';

const APPURL = require('../../Constants/URLConstants');

/**
 * Get categories by type
 * @param {object} params - Query parameters
 * @returns {Promise<object>} - Response with categories array
 */
export const getCategories = async (params = {}) => {
  try {
    const {
      type = 'listings',
      parent = 0, // 0 for top-level categories
      page = 1,
      perPage = 100,
    } = params;

    // Build URL properly without duplicate parameters
    // URLConstants.categories is 'v1/categories?parent=0&type='
    const url = `${APPURL.URLPaths.categories}${type}&page=${page}&per_page=${perPage}`;

    const response = await network.networkCall(
      url,
      'GET',
      '',
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

/**
 * Get single category by ID
 * @param {number} categoryId - Category ID
 * @returns {Promise<object>} - Response with category data
 */
export const getCategoryById = async (categoryId) => {
  try {
    const response = await network.networkCall(
      `${APPURL.URLPaths.categories}/${categoryId}`,
      'GET',
      '',
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error fetching category:', error);
    throw error;
  }
};

/**
 * Get category by slug
 * @param {string} slug - Category slug
 * @returns {Promise<object>} - Response with category data
 */
export const getCategoryBySlug = async (slug) => {
  try {
    const response = await network.networkCall(
      `${APPURL.URLPaths.categories}/slug/${slug}`,
      'GET',
      '',
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error fetching category by slug:', error);
    throw error;
  }
};

/**
 * Create a new category
 * @param {object} categoryData - Category data
 * @returns {Promise<object>} - Response with created category
 */
export const createCategory = async (categoryData) => {
  try {
    const response = await network.networkCall(
      APPURL.URLPaths.categories,
      'POST',
      JSON.stringify({ category: categoryData }),
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error creating category:', error);
    throw error;
  }
};

/**
 * Update a category
 * @param {number} categoryId - Category ID
 * @param {object} categoryData - Updated category data
 * @returns {Promise<object>} - Response with updated category
 */
export const updateCategory = async (categoryId, categoryData) => {
  try {
    const response = await network.networkCall(
      `${APPURL.URLPaths.categories}/${categoryId}`,
      'PUT',
      JSON.stringify({ category: categoryData }),
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error updating category:', error);
    throw error;
  }
};

/**
 * Delete a category
 * @param {number} categoryId - Category ID
 * @returns {Promise<object>} - Response
 */
export const deleteCategory = async (categoryId) => {
  try {
    const response = await network.networkCall(
      `${APPURL.URLPaths.categories}/${categoryId}`,
      'DELETE',
      '',
      '',
      '',
    );

    return response;
  } catch (error) {
    console.error('Error deleting category:', error);
    throw error;
  }
};
